import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var OwnerDistributionCalculation =
/*#__PURE__*/
function (_BaseData) {
  _inherits(OwnerDistributionCalculation, _BaseData);

  function OwnerDistributionCalculation() {
    _classCallCheck(this, OwnerDistributionCalculation);

    return _possibleConstructorReturn(this, _getPrototypeOf(OwnerDistributionCalculation).call(this, "OwnerDistributionCalculation"));
  }

  return OwnerDistributionCalculation;
}(BaseData);

export default new OwnerDistributionCalculation();